module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kong-box"
  }, [_c('div', {
    staticClass: "kong"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/kong.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.zanwushuju')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b7b57be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kong/kong.vue
// module id = 1014
// module chunks = 1